import html2canvas from 'html2canvas'

type imageFormat = 'jpeg' | 'png'

export async function imageFromDom (elem: HTMLElement, scale: number = 1, format: imageFormat = 'png', quality = 1.0) {
  const canvasOrg = await html2canvas(elem, { scale: 1.0 })
  const canvasResized = document.createElement('canvas')
  const ctx = canvasResized.getContext('2d')
  if (ctx) {
    const ow = canvasOrg.width
    const oh = canvasOrg.height
    canvasResized.width = ow * scale
    canvasResized.height = oh * scale
    ctx.drawImage(canvasOrg, 0, 0, ow, oh, 0, 0, ow * scale, oh * scale)
  }
  // document.body.appendChild(canvasResized)
  return canvasResized.toDataURL(`image/${format}`, quality)
}
